import { render, staticRenderFns } from "./Produktgruppe.vue?vue&type=template&id=25ed6be5&"
import script from "./Produktgruppe.vue?vue&type=script&lang=js&"
export * from "./Produktgruppe.vue?vue&type=script&lang=js&"
import style0 from "./Produktgruppe.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports